export default "__VITE_ASSET__Dp_68dRg__"